var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
function getCurrentSeason() {
    var currentDate = new Date();
    if (currentDate.getMonth() < 5) {
        return (10000 * (currentDate.getFullYear() - 1)) + currentDate.getFullYear();
    }
    else {
        return (10000 * (currentDate.getFullYear()) + currentDate.getFullYear() + 1);
    }
}
var CurrentSeasonContext = createContext(null);
export function useCurrentSeasonContext() {
    var context = useContext(CurrentSeasonContext);
    if (context === null) {
        throw new Error('useCurrentSeasonContext must be used within a CurrentSeasonContext');
    }
    return context;
}
export function CurrentSeasonContextProvider(props) {
    var _a = useState(getCurrentSeason()), currentSeasonNumber = _a[0], setCurrentSeasonNumber = _a[1];
    var _b = useState(""), currentSeasonString = _b[0], setCurrentSeasonString = _b[1];
    useEffect(function () {
        var firstYear = Math.floor(currentSeasonNumber / 10000);
        var secondYear = firstYear + 1;
        setCurrentSeasonString("".concat(firstYear, "/").concat(secondYear));
    }, [currentSeasonNumber]);
    return (_jsx(CurrentSeasonContext.Provider, __assign({ value: { currentSeasonNumber: currentSeasonNumber, currentSeasonString: currentSeasonString } }, { children: props.children })));
}
